

export enum RequestType {
    POST, GET, PUT, DELETE, HEAD
}
